import { initializeApp, getApps } from "firebase/app";
import { 
  getFirestore, 
  collection, 
  onSnapshot, 
  addDoc, 
  doc, 
  updateDoc, 
  getDoc, 
  setDoc, 
  getDocs, 
  query, 
  where 
} from "firebase/firestore";

// 1. Configuración Oficial de Cloud Firestore (EOH-Educativo - Base de Datos Activa)
const configEoh = {
  projectId: "eoh-educativo",
  appId: "1:327961687279:web:a7817e365b5428c522d71a",
  storageBucket: "eoh-educativo.firebasestorage.app",
  apiKey: "AIzaSyD3vY7bwx034FNSfTmR_UcRh5KzQ8rbZic",
  authDomain: "eoh-educativo.firebaseapp.com",
  messagingSenderId: "327961687279",
  measurementId: "G-J7EBZ0N7CD"
};

// 2. Configuración de Respaldo Redundante (motor-pedagogico-eoh)
const configSecondary = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAiU6dOFOBt6OVKrsymCfO6b-OW5L7w8H4",
  authDomain: "motor-pedagogico-eoh.firebaseapp.com",
  projectId: "motor-pedagogico-eoh",
  storageBucket: "motor-pedagogico-eoh.firebasestorage.app",
  messagingSenderId: "326449675951",
  appId: "1:326449675951:web:6640f8645d29f3f82d9e5a"
};

// Inicializar apps de Firebase
const appEoh = getApps().find(a => a.name === "appEoh") || initializeApp(configEoh, "appEoh");
const appSecondary = getApps().find(a => a.name === "appSecondary") || initializeApp(configSecondary, "appSecondary");

export const dbEoh = getFirestore(appEoh);
export const dbSecondary = getFirestore(appSecondary);
export const db = dbEoh; // Base de datos primaria activa

// Guardar actividad en la nube de Firebase (eoh-educativo)
export async function saveActivityToCloud(activityRecord) {
  const payload = {
    ...activityRecord,
    timestamp: new Date().toISOString()
  };
  try {
    await addDoc(collection(dbEoh, "activities"), payload);
    console.log("[Firebase] Actividad guardada exitosamente en eoh-educativo");
  } catch (e) {
    console.warn("Fallo guardando en DB EOH-Educativo:", e);
  }
  try {
    await addDoc(collection(dbSecondary, "activities"), payload);
  } catch (e) {}
}

// Guardar estudiante en la nube de Firebase (eoh-educativo)
export async function saveStudentToCloud(studentRecord) {
  const payload = {
    ...studentRecord,
    timestamp: new Date().toISOString()
  };
  try {
    await addDoc(collection(dbEoh, "students"), payload);
    console.log("[Firebase] Estudiante guardado exitosamente en eoh-educativo");
  } catch (e) {
    console.warn("Fallo guardando estudiante en DB EOH-Educativo:", e);
  }
  try {
    await addDoc(collection(dbSecondary, "students"), payload);
  } catch (e) {}
}

/**
 * Escucha en tiempo real la colección en Firebase
 * y combina automáticamente todos los registros de los estudiantes.
 */
export function listenToUnifiedCollection(collectionName, onCombinedUpdate) {
  let docsEoh = [];
  let docsSecondary = [];

  const mergeAndNotify = () => {
    const combinedMap = new Map();
    [...docsEoh, ...docsSecondary].forEach(docItem => {
      const key = docItem.pin || docItem.code || docItem.id || docItem.username || (docItem.name + docItem.topic + docItem.date + (docItem.score || ''));
      if (key && !combinedMap.has(key)) {
        combinedMap.set(key, docItem);
      }
    });
    onCombinedUpdate(Array.from(combinedMap.values()));
  };

  const unsub1 = onSnapshot(collection(dbEoh, collectionName), (snapshot) => {
    docsEoh = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
    mergeAndNotify();
  }, (err) => console.warn(`[Firebase] Conexión DB (${collectionName}):`, err));

  const unsub2 = onSnapshot(collection(dbSecondary, collectionName), (snapshot) => {
    docsSecondary = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
    mergeAndNotify();
  }, (err) => {});

  return () => {
    unsub1();
    unsub2();
  };
}

// =========================================================================
// SISTEMA DE PIN DINÁMICO MULTIDISPOSITIVO (NUBE EN TIEMPO REAL)
// =========================================================================

/**
 * Genera un PIN de 6 dígitos en Firestore con ID de documento = PIN
 * para acceso instantáneo O(1) desde cualquier celular, tablet o computador.
 */
export async function generateExamPinInCloud(grade, unit, teacherName = "Prof. Didier") {
  const pinNumber = Math.floor(100000 + Math.random() * 900000).toString(); // PIN de 6 dígitos ej: 849201
  const now = new Date();
  const expiresAt = new Date(now.getTime() + 10 * 60 * 1000).toISOString(); // 10 minutos de vigencia

  const payload = {
    pin: pinNumber,
    grade: String(grade),
    unit: Number(unit),
    teacher: teacherName,
    createdAt: now.toISOString(),
    expiresAt: expiresAt,
    isActive: true,
    studentsEntered: []
  };

  // 1. Guardar de inmediato en localStorage para respuesta instantánea en el dispositivo docente
  const localPins = JSON.parse(localStorage.getItem('motor_pedagogico_exam_pins') || '[]');
  localPins.unshift(payload);
  localStorage.setItem('motor_pedagogico_exam_pins', JSON.stringify(localPins));
  localStorage.setItem('motor_pedagogico_last_active_pin', JSON.stringify(payload));

  // 2. Guardar en Firestore eoh-educativo con ID de documento igual al PIN para búsqueda O(1) directa
  try {
    await setDoc(doc(dbEoh, "exam_pins", pinNumber), payload);
    console.log(`[Firebase] PIN ${pinNumber} registrado exitosamente en eoh-educativo`);
  } catch (e) {
    console.warn("[Firebase] Error registrando PIN en Firestore:", e);
  }

  try {
    await setDoc(doc(dbSecondary, "exam_pins", pinNumber), payload);
  } catch (e) {}

  return payload;
}

/**
 * Desactiva o invalida un PIN en Firestore de forma manual
 */
export async function deactivateExamPinInCloud(pinNumber) {
  const cleanPin = String(pinNumber || '').trim();
  if (!cleanPin) return;

  const updateData = {
    isActive: false,
    closedAt: new Date().toISOString()
  };

  try {
    await updateDoc(doc(dbEoh, "exam_pins", cleanPin), updateData);
  } catch (e) {}

  try {
    await updateDoc(doc(dbSecondary, "exam_pins", cleanPin), updateData);
  } catch (e) {}

  // Actualizar localStorage local
  const lastActive = JSON.parse(localStorage.getItem('motor_pedagogico_last_active_pin') || 'null');
  if (lastActive && String(lastActive.pin).trim() === cleanPin) {
    localStorage.setItem('motor_pedagogico_last_active_pin', JSON.stringify({ ...lastActive, ...updateData }));
  }
}

/**
 * Valida un PIN de Evaluación desde CUALQUIER Dispositivo (Celulares, Tablets, PC).
 * Búsqueda directa O(1) en Firestore con fallback automático.
 */
export async function validateAndConsumeExamPin({ pinInput, gradeInput, unitInput, studentName, studentCode }) {
  const cleanPin = String(pinInput || '').trim();
  if (!cleanPin || cleanPin.length < 4) {
    return {
      success: false,
      reason: "Por favor ingresa un PIN válido de 6 dígitos."
    };
  }

  const nowTime = new Date().getTime();

  // Función de evaluación del documento de PIN
  const evaluatePinData = async (pinData, docRefEoh, docRefSecondary) => {
    const expTime = new Date(pinData.expiresAt).getTime();

    if (pinData.isActive === false) {
      return {
        success: false,
        reason: "Este PIN ha sido desactivado por el profesor. Solicita un nuevo PIN activo."
      };
    }

    if (nowTime > expTime) {
      return {
        success: false,
        reason: "Este PIN de 10 minutos ha expirado. Solicita un nuevo PIN proyectado al profesor."
      };
    }

    // Registrar ingreso del estudiante en la lista de accesos del PIN en Firestore
    const studentEntry = {
      name: studentName || 'Estudiante EOH',
      code: studentCode || '',
      enteredAt: new Date().toISOString()
    };

    const currentList = Array.isArray(pinData.studentsEntered) ? pinData.studentsEntered : [];
    const updatedList = [...currentList, studentEntry];

    if (docRefEoh) {
      updateDoc(docRefEoh, {
        studentsEntered: updatedList,
        lastAccessedAt: new Date().toISOString()
      }).catch(() => {});
    }
    if (docRefSecondary) {
      updateDoc(docRefSecondary, {
        studentsEntered: updatedList,
        lastAccessedAt: new Date().toISOString()
      }).catch(() => {});
    }

    return {
      success: true,
      pinData: {
        ...pinData,
        grade: String(pinData.grade || gradeInput || '6'),
        unit: Number(pinData.unit || unitInput || 1)
      }
    };
  };

  // 1. Consulta Directa O(1) en Firestore por ID de documento (Mínima latencia y alta confiabilidad)
  try {
    const snapEoh = await getDoc(doc(dbEoh, "exam_pins", cleanPin));
    if (snapEoh.exists()) {
      return await evaluatePinData(
        snapEoh.data(),
        doc(dbEoh, "exam_pins", cleanPin),
        doc(dbSecondary, "exam_pins", cleanPin)
      );
    }
  } catch (err) {
    console.warn("[Firebase] Consulta directa dbEoh:", err);
  }

  try {
    const snapSecondary = await getDoc(doc(dbSecondary, "exam_pins", cleanPin));
    if (snapSecondary.exists()) {
      return await evaluatePinData(
        snapSecondary.data(),
        null,
        doc(dbSecondary, "exam_pins", cleanPin)
      );
    }
  } catch (err) {
    console.warn("[Firebase] Consulta directa dbSecondary:", err);
  }

  // 2. Consulta por Query en la Colección (Por si se almacenó con ID autogenerado)
  try {
    const q = query(collection(dbEoh, "exam_pins"), where("pin", "==", cleanPin));
    const qSnap = await getDocs(q);
    if (!qSnap.empty) {
      const pinDoc = qSnap.docs[0];
      return await evaluatePinData(pinDoc.data(), pinDoc.ref, null);
    }
  } catch (err) {
    console.warn("[Firebase] Query dbEoh:", err);
  }

  try {
    const q = query(collection(dbSecondary, "exam_pins"), where("pin", "==", cleanPin));
    const qSnap = await getDocs(q);
    if (!qSnap.empty) {
      const pinDoc = qSnap.docs[0];
      return await evaluatePinData(pinDoc.data(), null, pinDoc.ref);
    }
  } catch (err) {
    console.warn("[Firebase] Query dbSecondary:", err);
  }

  // 3. Fallback en LocalStorage (Por si es el mismo dispositivo del docente)
  const localPins = JSON.parse(localStorage.getItem('motor_pedagogico_exam_pins') || '[]');
  const lastActive = JSON.parse(localStorage.getItem('motor_pedagogico_last_active_pin') || 'null');
  const localCandidates = [...localPins];
  if (lastActive) localCandidates.unshift(lastActive);

  const localMatch = localCandidates.find(p => String(p.pin).trim() === cleanPin);
  if (localMatch) {
    return await evaluatePinData(localMatch, null, null);
  }

  return {
    success: false,
    reason: `El PIN "${cleanPin}" no fue encontrado en la nube. Verifica los 6 dígitos proyectados por el profesor.`
  };
}